import {DetailData} from "./structs/DetailData";
import {Api} from "./Api";
import {loadScript} from "./tools/loadScript";
import {isInViewport} from "./tools/isInViewport";
import {GpsPos} from "./maps/igps";
import {Zp, ZpDate} from "./Zp";
import {ZpCalendar} from "./ZpCalendar";
import {PreisRechner} from "./PreisRechner";
import {ReqPriceData, ResPriceData} from "./structs/PriceData";
import {getHashParamInt} from "./tools/hashParam";

export class Detail {
    static data: DetailData = null;

    private static _runList: Array<() => void> = [];

    private static _runInternal(func: () => void) {
        if (typeof func == "undefined" || func == null) {
            func = () => {
            };
        }
        if (Detail.data == null) {
            Detail._runList.push(func);
        } else {
            func();
            for (let f of Detail._runList) {
                f();
            }
        }
    }

    static formatPrice(price: number) {
        if (Detail.data) {
            const parts = price.toFixed(2).split('.');
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, Detail.data.price_sep) + Detail.data.price_dot + parts[1];
        }
        return price.toFixed(2);
    }

    static init() {
        Api.detailData("", data => {
            Detail.data = data;
            Detail._runInternal(() => {
                const p = new GpsPos(data.map_pos);
                if (p.isValid()) {
                    data.hasMap = true;
                    data.lat = p.lat();
                    data.long = p.long();
                }
                if (data.vac_data && data.vac_data.length % 2 == 0) {
                    let o = "";
                    for (let i = 0; i < data.vac_data.length; i += 2) {
                        o += data.vac_data.charAt(i + 1).repeat(data.vac_data.charCodeAt(i) - 96)
                    }
                    if (o.length % 3 == 0) {
                        data.arrival = o.substring(0, o.length / 3);
                        data.departure = o.substring(o.length / 3, o.length / 3 * 2);
                        data.vacancy = o.substring(o.length / 3 * 2, o.length);
                    }
                }
            });
        });

        $((): void => {
            const targetDiv = $('#acco-map');
            if (targetDiv.length) {
                const check = () => {
                    if (!Detail._runMapActive && isInViewport(targetDiv)) {
                        Detail.runMap();
                    }
                };
                $(document).on('scroll', () => {
                    check();
                });
                check();
            }

            Detail.runSidepanel();
        });

        // --- Calendar Click ---
        $(".checkin").on("click", function () {
            Detail.calFrom = 0;
            Detail.calTill = 0;
            Detail._calDisplayCheckInOut();
            Detail._openCalendar();
            Detail.cal.posRefElement($("#acco-book:visible .form-group, #acco-book-xs:visible .form-group").first(), $(this), {top: 115, left: 30, arrOfs: 0})
        });
        $(".checkout").on("click", function () {
            Detail._openCalendar();
            Detail.cal.posRefElement($("#acco-book:visible .form-group, #acco-book-xs:visible .form-group").first(), $(this), {top: 115, left: 0, arrOfs: 30})
        });
        $("body").on("click", (ev) => {
            for (let el = $(ev.target); el.length > 0; el = el.parent()) {
                if (el.hasClass("calendar-modern") || el.hasClass("dates")) return; // eigener Kalender-Klick erkannt?
                if (el.hasClass("checkin") || el.hasClass("checkout") || el.hasClass("btn")) return; // Formular-Felder und Button Check
            }
            Detail._closeCalendar();
            Detail._calRefresh();
        });

        // --- Pax Click ---
        $("#acco-book select, #acco-book-xs select").on('change', function () {
            Detail.calPax = parseInt($(this).val() as string);
            Detail._calRefresh();
        });

        // --- Suchparameter Übergabe (per Hashtag) ---
        const checkin = getHashParamInt("checkin");
        const duration = getHashParamInt("duration");
        const pax = getHashParamInt("pax");
        if (checkin && Zp.fromVacandoTs(checkin) >= Zp.today() && Zp.fromVacandoTs(checkin) < Zp.today() + 1024 && duration > 0 && duration <= 28 && pax > 0 && pax < 999) {
            Detail.calFrom = Zp.fromVacandoTs(checkin);
            Detail.calTill = Zp.fromVacandoTs(checkin) + duration;
            Detail.calPax = pax;
            Detail._calDisplayCheckInOut();
            $("#acco-book select, #acco-book-xs select").val(Detail.calPax);
            Detail._calRefresh();
        }
    }

    static cal: ZpCalendar;
    static calFrom: ZpDate = 0;
    static calTill: ZpDate = 0;
    static calPax = 1;
    static prFrom: ZpDate = 0;
    static prTill: ZpDate = 0;
    static prPax = 1;
    static txtHeaderDefault = "";
    static priceResult: ResPriceData = null;

    private static _preisrechnerDisplay(p: ResPriceData) {
        const $acco = $("#acco-book:visible").length ? $("#acco-book:visible") : $("#acco-book-xs:visible");
        const jheader = $acco.find(".book-header");
        if (Detail.txtHeaderDefault === "") {
            Detail.txtHeaderDefault = jheader.html();
        }
        // immer zuerst alten Output bereinigen
        $("#price-result, #price-result-xs").html("");

        if (p && p.price) {
            Detail.priceResult = p;
            jheader.html("<span><strong>" + p.currency + "</strong> <strong class=\"brand-primary-1-text\">" + Detail.formatPrice(p.price / p.nights) + "</strong></span> " + p.txt_per_night);
            $("#price-result, #price-result-xs").html(`<table class="table service-cost">
                                        <tbody>
                                            <tr>
                                                <td>` + p.txt_price_for + ` <span>` + p.nights + ` ` + p.txt_night_plural + `</span></td>
                                                <td class="text-right">` + p.currency + ` ` + Detail.formatPrice(p.price) + `</td>
                                            </tr>
                                            <tr>
                                                <td>` + p.txt_service_fee + `</td>
                                                <td class="text-right">` + p.currency + ` ` + Detail.formatPrice(0) + `</td>
                                            </tr>
                                            <tr>
                                                <td class="amount">` + p.txt_base_price + `</td>
                                                <td class="text-right amount text-nowrap">` + p.currency + ` ` + Detail.formatPrice(p.price) + `</td>
                                            </tr>
                                        </tbody>
                                        </table>`);
        } else {
            Detail.priceResult = null;
            // Bei blockiert/nicht verfügbar: Header zurück auf Default und Hinweis im price-result
            const notAvail = p && p.txt_not_available ? p.txt_not_available : "not available";
            jheader.html(Detail.txtHeaderDefault);
            $("#price-result, #price-result-xs").html("<div style='text-align:center;margin:8px 0 12px'><span style='color:#e00;font-weight:bold'>" + notAvail + "</span></div>");
        }
    }

    static book() { // Öffnet die Buchungsseite
        const pr = Detail.priceResult;
        if (pr) {
            const url = PreisRechner.bookUrl(pr);
            console.log("open booking: " + url);
            window.open(url, "_blank");
        } else {
            Detail._openCalendar();
        }
    }

    private static _calRefresh() {
        let d1 = Detail.calFrom;
        let d2 = Detail.calTill;
        if (d1 && d2) {
            if (d1 > d2) {
                const t = d1;
                d1 = d2;
                d2 = t;
            }
                if (d1 != Detail.prFrom || d2 != Detail.prTill || Detail.calPax != Detail.prPax) {
                    Detail.prFrom = d1;
                    Detail.prTill = d2;
                    Detail.prPax = Detail.calPax;

                    // --- Run Preisrechner ---
                    // Vor Start: Anzeige zurücksetzen, damit alte Meldung/Preis sofort verschwindet
                    Detail.priceResult = null;
                    $("#price-result, #price-result-xs").html("");
                    const r: ReqPriceData = {
                        check_in: Zp.iso(Detail.prFrom),
                        check_out: Zp.iso(Detail.prTill),
                        pax: Detail.prPax
                    };
                PreisRechner.request(r, (res: ResPriceData) => {
                    Detail._preisrechnerDisplay(res);
                });
            }
        }
    }

    private static _calDisplayCheckInOut(d2?: ZpDate) {
        let d1 = Detail.calFrom;
        if (!d2) d2 = Detail.calTill;
        if (d2 < d1 && d2 != 0) {
            const t = d1;
            d1 = d2;
            d2 = t;
        }
        if (d1 == d2) d2 = 0;
        $(".checkin").val(d1 ? Zp.format(d1) : "");
        $(".checkout").val(d2 ? Zp.format(d2) : "");
    }

    private static _openCalendar() {
        if (Detail.cal) return;
        Detail.cal = new ZpCalendar(Detail.calFrom, (el, d) => {
            Detail.calTill = Detail.calFrom;
            Detail.calFrom = d;
            if (!Detail.calTill) Detail.calTill = Detail.calFrom;
            Detail.cal.markDays(Detail.calFrom, Detail.calTill);
            Detail._calDisplayCheckInOut();
            if (Detail.calFrom && Detail.calTill && Detail.calFrom > Detail.calTill) { // Rückwärts Reihenfolge = Abreise als letztes geklickt
                Detail._calRefresh();
                Detail._closeCalendar();
            }
            // Detail._closeCalendar();
        }, (el, d, hov) => {
            if (!Detail.cal || !Detail.calFrom) return;
            if (hov) {
                Detail.cal.markDays(Detail.calFrom, d);
                Detail._calDisplayCheckInOut(d);
            } else {
                Detail.cal.markDays(Detail.calFrom, Detail.calTill);
                Detail._calDisplayCheckInOut();
            }
        }, 1);
        if (Detail.calFrom && Detail.calTill) Detail.cal.markDays(Detail.calFrom, Detail.calTill);
        $("#acco-book:visible .form-group, #acco-book-xs:visible .form-group").first().append(Detail.cal.calendarDiv);
    }

    private static _closeCalendar() {
        if (Detail.cal) {
            Detail.cal.calendarDiv.remove();
            Detail.cal = null;
        }
        if ((Detail.calFrom !== 0 && Detail.calTill === 0) || (Detail.calFrom == Detail.calTill)) {
            Detail.calFrom = 0;
            Detail.calTill = 0;
        }
        Detail._calDisplayCheckInOut();
    }

    static runSidepanel() {
        Detail._runInternal(() => {
            const d = Detail.data;
            $(".pass").html(d.support_id);

            $('#acco-book').affix({
                offset: {
                    top: 554,
                    bottom: 245
                }
            });
        })
    }

    private static _runMapActive: boolean

    static runMap() {
        if (Detail._runMapActive) {
            return
        }
        Detail._runMapActive = true;
        console.log("runMap.");
        Detail._runInternal(() => {
            if (Detail.data.hasMap) {
                let map;

                const googleMapsUrl = "https://kk.vacando.com/js/m1?lang=" + window.pageInfo.lang + "&callback=initDetailMap";

                (<any>window).initDetailMap = () => {
                    const pos = new GpsPos(Detail.data.map_pos);
                    const myLatLng = new google.maps.LatLng(pos.lat(), pos.long());
                    const divs = $('#acco-map')
                    if (divs.length === 0) {
                        return;
                    }
                    map = new google.maps.Map(divs[0], {
                        center: myLatLng,
                        scaleControl: true,
                        zoomControl: true,
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.TOP_RIGHT
                        },
                        scrollwheel: true,
                        minZoom: 6,
                        zoom: 13
                    });
                    new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        title: Detail.data.title
                    });
                }

                loadScript(googleMapsUrl, null);
            }
        })
    }
}
